import React from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useAuth } from "./authContext";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const token = localStorage.getItem("serviceToken");

  if (!isAuthenticated || !token) {
    return <Navigate to="/login" replace />;
  }

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;

    if (!decoded.exp || decoded.exp < currentTime) {
      localStorage.removeItem("serviceToken");
      localStorage.removeItem("isAuthenticated");
      return <Navigate to="/login" replace />;
    }
  } catch (error) {
    localStorage.removeItem("serviceToken");
    localStorage.removeItem("isAuthenticated");
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
